import CalculatedData from "./CalculatedData";

const CalculatedDataContainer = ({
  activePosition,
  proCalculationCharts,
  calculation,
  conclusionsPro,
  onPositionChange
}: {
  activePosition: 10 | 20 | 30,
  proCalculationCharts: any,
  calculation: any,
  conclusionsPro: any,
  onPositionChange: (position: 10 | 20 | 30) => void
}) => {

  return (
    <CalculatedData
      activePosition={activePosition}
      proCalculationCharts={proCalculationCharts}
      calculation={calculation}
      conclusionsPro={conclusionsPro}
      onPositionChange={onPositionChange}
    />
  );
};

export default CalculatedDataContainer;
